"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body style={{ margin: 0, minHeight: "100vh", background: "#18181b", color: "#fff", fontFamily: "system-ui, sans-serif" }}>
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "1.5rem",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "1.5rem", fontWeight: 700, marginBottom: "0.5rem" }}>
            Something went wrong
          </h1>
          <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.875rem", marginBottom: "1.5rem", maxWidth: "24rem" }}>
            We&apos;ve been notified and are looking into it. You can try going back to the app.
          </p>
          <a
            href="/"
            style={{
              display: "inline-block",
              padding: "0.75rem 1.5rem",
              background: "#fff",
              color: "#18181b",
              fontWeight: 600,
              borderRadius: "0.75rem",
              textDecoration: "none",
              fontSize: "1rem",
            }}
          >
            Go to home
          </a>
        </div>
      </body>
    </html>
  );
}
